// Приложения и утилиты для скачивания, сгруппированы по назначению.
// Используются на странице логина (модалка «Приложения») и в разделе «Помощь».
export const APP_GROUPS = [
	{
		title: 'apps_group_mison',
		items: [
			{ name: 'Mison Kassa', type: 'desktop_client', action: 'download', url: (version) => `https://download.mison.uz/desktop_client/Mison${version}(x64).exe` },
			{ name: 'Mison Owner', type: 'android_owner', action: 'copy', url: () => 'https://onelink.to/2aheb2' },
			{ name: 'Mison Waiter', type: 'waiter_android', action: 'copy', url: () => 'https://onelink.to/28k4yb' },
			{ name: 'Mison Delivery', type: 'android_delivery', action: 'copy', url: () => 'https://onelink.to/c2yxv2' },
		]
	},
	{
		title: 'apps_group_printers',
		items: [
			{ name: 'XPrinter Driver Setup V7.77', action: 'download', url: () => 'https://download.mison.uz/files/XPrinterV7.77.exe' },
			{ name: 'XPrinter 80', action: 'download', url: () => 'https://download.mison.uz/files/xprinter_80.exe' },
			{ name: 'XPrinter V3.0C', action: 'download', url: () => 'https://download.mison.uz/files/XPrinterV3.0C.rar' },
			{ name: 'XPrinter 2018.1', action: 'download', url: () => 'https://download.mison.uz/files/Xprinter_2018.1.exe' },
		]
	},
	{
		title: 'apps_group_terminals',
		items: [
			{ name: 'ARCUS (Uzcard)', action: 'download', url: () => 'https://download.mison.uz/files/arcus2.exe' },
		]
	},
	{
		title: 'apps_group_utils',
		items: [
			{ name: 'PostgreSQL 12', action: 'download', url: () => 'https://download.mison.uz/files/postgresql_12.exe' },
			{ name: 'Winrar', action: 'download', url: () => 'https://download.mison.uz/files/winrar.exe' },
			{ name: 'FiscalDriveAPI', action: 'download', url: () => 'https://download.mison.uz/files/FiscalDriveAPI3448.exe' },
			{ name: 'FiscalDriveService', action: 'download', url: () => 'https://download.mison.uz/files/FiscalDriveService3449.exe' },
			{ name: 'BioAccess', action: 'download', url: () => 'https://download.mison.uz/files/BioAccess.exe' },
			{ name: 'BioAccess Driver', action: 'download', url: () => 'https://download.mison.uz/files/BioAccessDriver.exe' },
			{ name: 'AnyDesk', action: 'download', url: () => 'https://download.mison.uz/files/anydesk.exe' },
			{ name: 'AmmyAdmin 3.10', action: 'download', url: () => 'https://download.mison.uz/files/ammyadmin.exe' },
			{ name: 'TeamViewer', action: 'download', url: () => 'https://download.mison.uz/files/Teamviewer.exe' },
		]
	},
]

// Контакты поддержки и ссылки на документацию — в одном месте,
// чтобы менять номер или адрес не приходилось по нескольким страницам.
export const SUPPORT = {
	phone: '+998787070089',
	phone_formatted: '+998 78 707-00-89',
	// TODO: подставить реальный чат поддержки
	telegram: 'https://t.me/mison_support',
	docs_url: 'https://doc.mison.uz/web/documents_in',
	api_docs_url: 'https://api.mison.uz',
}

// Ссылка на страницу doc.mison.uz на языке кабинета: русская локаль в корне, узбекская — в /uz/
export function docsPageUrl(slug, language) {
	const prefix = String(language || '').startsWith('uz') ? '/uz' : ''
	return 'https://doc.mison.uz' + prefix + '/web/' + slug
}
